import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Button } from '../components/ui';

export function NotFoundPage() {
  return (
    <div className="flex min-h-full items-center justify-center px-4 py-16">
      <div className="text-center">
        <p className="text-5xl font-semibold text-brand-600">404</p>
        <p className="mt-3 text-sm font-medium text-ink">გვერდი ვერ მოიძებნა</p>
        <p className="mt-1 text-[13px] text-ink-mute">შესაძლოა მისამართი შეიცვალა ან წაიშალა.</p>
        <Link to="/" className="mt-5 inline-block">
          <Button variant="secondary" icon={<Home className="size-4" />}>
            მთავარზე დაბრუნება
          </Button>
        </Link>
      </div>
    </div>
  );
}
